/* Good-enough address check — the backend validates properly, this just keeps
   obvious typos out of the saved list. */
export const isValidEmail = (v) => /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]{2,}$/.test(String(v).trim());

/* One typed string → the addresses in it. Accepts commas, semicolons, spaces
   and newlines as separators so a pasted list works as-is. */
export const parseEmailList = (raw) =>
  String(raw || '')
    .split(/[\s,;]+/)
    .map((e) => e.trim())
    .filter(Boolean);

/* Case-insensitive de-dupe, keeping the first spelling of each address. */
export const uniqueEmails = (list) => {
  const seen = new Set();
  return (list || []).filter((e) => {
    const key = String(e).trim().toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
